
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advisory-farmers-helpline-and-support",
      function () {
        return require("private-next-pages/advisory-farmers-helpline-and-support.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advisory-farmers-helpline-and-support"])
      });
    }
  